import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AccountStatus, Filter } from 'cat-shared/utils'
import { Menu, Dropdown } from 'client/semantic-imports'
import { AppHeader, AppNotifications } from 'client/ui-building-blocks'
import { ActivityList } from 'client/components'
import { FormName } from 'client/utils'
import { removeLocalAuthUser, killUserSocket, killQuestionSocket } from 'client/services'

import {
  useAppContext,
  useModalDialogContext,
  usePage,
  usePageStateContext,
} from 'client/hooks'

import styles from './top-bar.module.scss'
import './top-bar.scss'

type Props = {
  accountStatus: AccountStatus
  getOnClickHandler: (path: string, action?: string) => () => void
}

const TopBarAccountDropdown = ({ accountStatus, getOnClickHandler }: Props) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const { navigateTo } = usePage()
  const { closeAllModals } = useModalDialogContext()

  const { setAuthUser, showAppNotifications, setShowAppNotifications } = useAppContext()

  const {
    setSettingsPageState,
    setBrowseQuestionsPageState,
    authForm,
    setRandomizerCategory,
  } = usePageStateContext()

  const onLogoutClick = () => {
    killUserSocket()
    killQuestionSocket()
    removeLocalAuthUser()
    setSettingsPageState({ tabNo: 1 })
    setBrowseQuestionsPageState(state => ({
      ...state,
      filter: Filter.Answered,
      category: 'any',
      search: '',
      pageNo: 1,
    }))
    setAuthUser(null)
    setRandomizerCategory('any')
    closeAllModals()
    if (showAppNotifications) {
      setShowAppNotifications(false)
    }
    navigateTo({ path: '/auth' })
  }

  const onNotificationsIconClick = e => {
    e.stopPropagation()
    setShowAppNotifications(!showAppNotifications)
  }

  return (
    <>
      <AppNotifications>
        <ActivityList />
      </AppNotifications>
      <Menu.Menu position="right">
        {accountStatus !== AccountStatus.UNKNOWN ? (
          <Menu.Item icon="bell" link onClick={onNotificationsIconClick} />
        ) : null}
        <Dropdown
          simple
          item
          aria-label="account"
          trigger={
            <AppHeader
              text={t('rootPage.topBar.menu.label')}
              color="light"
              size="small"
            />
          }
        >
          <Dropdown.Menu className={styles.menu}>
            {accountStatus !== AccountStatus.UNKNOWN && (
              <>
                <Dropdown.Item
                  onClick={getOnClickHandler('/profile')}
                  active={pathname === '/profile'}
                >
                  <AppHeader
                    text={t('rootPage.topBar.menu.items.profile')}
                    color="light"
                    size="small"
                  />
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={getOnClickHandler('/settings')}
                  active={pathname === '/settings'}
                >
                  <AppHeader
                    text={t('rootPage.topBar.menu.items.settings')}
                    color="light"
                    size="small"
                  />
                </Dropdown.Item>
              </>
            )}
            {accountStatus !== AccountStatus.UNKNOWN ? (
              <Dropdown.Item onClick={onLogoutClick}>
                <AppHeader
                  text={t('rootPage.topBar.menu.items.logout')}
                  color="light"
                  size="small"
                />
              </Dropdown.Item>
            ) : (
              <>
                <Dropdown.Item
                  onClick={getOnClickHandler('/auth', FormName.AuthenticationForm)}
                  active={
                    pathname === '/auth' && authForm === FormName.AuthenticationForm
                  }
                >
                  <AppHeader
                    text={t('rootPage.topBar.menu.items.login')}
                    color="light"
                    size="small"
                  />
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={getOnClickHandler('/auth', FormName.RegistrationForm)}
                  active={pathname === '/auth' && authForm === FormName.RegistrationForm}
                >
                  <AppHeader
                    text={t('rootPage.topBar.menu.items.register')}
                    color="light"
                    size="small"
                  />
                </Dropdown.Item>
              </>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </>
  )
}

export default TopBarAccountDropdown
